<template>
  <div class="emd-breadcrumb _mode_light">
    <ol>
      <router-link
        custom
        to="/"
        v-slot="{ navigate }"
        >
        <li class="emd-breadcrumb__item pointer" @click="navigate">
          {{ $t("breadcrumb.apps") }}
        </li>
      </router-link>
      <router-link
        v-if="appVisible"
        custom
        :to="{ path: `/application/${publicAppKey}/edit/` }"
        v-slot="{ navigate }"
        >
        <li class="emd-breadcrumb__item" @click="navigate">
          {{ app.name }}
        </li>
      </router-link>
      <router-link
        v-if="routeName === 'createApplication'"
        custom
        :to="{ path: `/application/create` }"
        v-slot="{ isExactActive, navigate }"
        >
        <li class="emd-breadcrumb__item" :class="{ _active: isExactActive }" @click="navigate">
          {{ $t("breadcrumb.create") }}
        </li>
      </router-link>
      <router-link
        v-if="appIsVisible('keys')"
        custom
        :to="{ name: 'application-keys', params: { publicAppKey } }"
        v-slot="{ isExactActive, navigate }"
        >
        <li class="emd-breadcrumb__item" :class="{ _active: isExactActive }" @click="navigate">
          {{ $t("breadcrumb.edit.keys") }}
        </li>
      </router-link>
      <router-link
        v-if="appIsVisible('generalDatas')"
        custom
        :to="{ name: 'application-generalDatas', params: { publicAppKey } }"
        v-slot="{ isExactActive, navigate }"
        >
        <li class="emd-breadcrumb__item" :class="{ _active: isExactActive }" @click="navigate">
          {{ $t("breadcrumb.edit.generalData") }}
        </li>
      </router-link>
      <router-link
        v-if="appIsVisible('descriptions')"
        custom
        :to="{ name: 'application-descriptions', params: { publicAppKey } }"
        v-slot="{ isExactActive, navigate }"
        >
        <li class="emd-breadcrumb__item" :class="{ _active: isExactActive }" @click="navigate">
          {{ $t("breadcrumb.edit.description") }}
        </li>
      </router-link>
      <router-link
        v-if="appIsVisible('images')"
        custom
        :to="{ name: 'application-images', params: { publicAppKey } }"
        v-slot="{ isExactActive, navigate }"
        >
        <li class="emd-breadcrumb__item" :class="{ _active: isExactActive }" @click="navigate">
          {{ $t("breadcrumb.edit.images") }}
        </li>
      </router-link>
      <router-link
        v-if="appIsVisible('callbacks')"
        custom
        :to="{ name: 'application-callbacks', params: { publicAppKey } }"
        v-slot="{ isExactActive, navigate }"
        >
        <li class="emd-breadcrumb__item" :class="{ _active: isExactActive }" @click="navigate">
          {{ $t("breadcrumb.edit.callbacks") }}
        </li>
      </router-link>
      <router-link
        v-if="appIsVisible('permissions')"
        custom
        :to="{ name: 'application-permissions', params: { publicAppKey } }"
        v-slot="{ isExactActive, navigate }"
        >
        <li class="emd-breadcrumb__item" :class="{ _active: isExactActive }" @click="navigate">{{ $t("breadcrumb.edit.permissions") }}</li>
      </router-link>
      <router-link
        v-if="appIsVisible('additionalData')"
        custom
        :to="{ name: 'application-additionalData', params: { publicAppKey } }"
        v-slot="{ isExactActive, navigate }"
        >
        <li class="emd-breadcrumb__item" :class="{ _active: isExactActive }" @click="navigate">{{ $t("breadcrumb.edit.additionalData") }}</li>
      </router-link>
      <router-link
        v-if="appIsVisible('security')"
        custom
        :to="{ name: 'application-security', params: { publicAppKey } }"
        v-slot="{ isExactActive, navigate }"
        >
        <li class="emd-breadcrumb__item" :class="{ _active: isExactActive }" @click="navigate">{{ $t("breadcrumb.edit.security") }}</li>
      </router-link>
      <router-link
        v-if="appIsVisible('review')"
        custom
        :to="{ name: 'application-review', params: { publicAppKey } }"
        v-slot="{ isExactActive, navigate }"
        >
        <li class="emd-breadcrumb__item" :class="{ _active: isExactActive }" @click="navigate">{{ $t("breadcrumb.edit.review") }}</li>
      </router-link>
    </ol>
  </div>
</template>
<script>
export default {
  name: 'EmdBreadcrumb',
  computed: {
    routeName: function () {
      return this.$route.name
    },
    publicAppKey: function () {
      return this.$route.params.publicAppKey
    },
    app: function () {
      return this.$store.state.application.detail
    },
    appVisible: function () {
      const patt = /application-/i
      return patt.test(this.$route.name)
    }
  },
  data () {
    return {}
  },
  methods: {
    appIsVisible (name) {
      const patt = new RegExp(name)
      return patt.test(this.routeName)
    }
  }
}
</script>
<style scoped>
  .pointer {
    cursor: pointer;
  }
</style>
